import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-sidenav',
  standalone: true,
  imports: [NgClass],
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
})
export class SidenavComponent {
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';

  @Input() opened = false;

  @Output() openedChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();

  @ViewChild('drawer', { static: true }) drawerRef!: ElementRef<HTMLElement>;

  public toggle(): Promise<'open' | 'close'> {
    return this[this.opened ? 'close' : 'open']();
  }

  public open(): Promise<'open' | 'close'> {
    return this.animateState(true);
  }

  public close(): Promise<'open' | 'close'> {
    return this.animateState(false);
  }

  private animateState(isOpen: boolean): Promise<'open' | 'close'> {
    this.opened = isOpen;
    this.openedChange.emit(this.opened);

    return new Promise((resolve) => {
      const el = this.drawerRef.nativeElement;
      const onEnd = (e: TransitionEvent) => {
        if (e.propertyName === 'transform') {
          el.removeEventListener('transitionend', onEnd);
          if (!isOpen) this.closed.emit();
          resolve(isOpen ? 'open' : 'close');
        }
      };
      el.addEventListener('transitionend', onEnd);
      setTimeout(() => {
        el.removeEventListener('transitionend', onEnd);
        resolve(isOpen ? 'open' : 'close');
      }, 350);
    });
  }
}
